import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../../../ui/TextField";
import DataSelect from "../../../../../../../../../ui/DataSelect";
import useAddExistingForm from "../../CreateFromExisting/AddExistingForm/useAddExistingForm";
import { transformNameInfoInitials } from "../../EmployeeCard";
import Avatar from "../../../../../../../../../ui/Avatar";

const defaultData = {
    postId: null,
    startDate: "",
    endDate: ""
};

const styles = () => ({
    root: {
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        },
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#000"
        }
    },
    checkbox: {
        "& > .MuiCheckbox-colorPrimary.Mui-checked": {
            color: "rgba(0, 127, 189, 0.7);"
        }
    },
    label: {
        fontSize: 12
    },
    heading: {
        fontSize: 14,
        lineHeight: "18px",
        display: "flex",
        alignItems: "center",
        color: "#000000",
        margin: "8px 0"
    },
    block: {
        margin: "35px 0 15px 0"
    },
    curator: {
        display: "flex",
        flexDirection: "row",
        marginTop: 20,
        alignItems: "center"
    },
    curatorPic: {
        marginRight: 17
    },
    avatarName: {
        fontSize: 14,
        color: "#000000"
    },
    avatarCaption: {
        marginTop: 10,
        fontSize: 10,
        textTransform: "uppercase",
        color: "#596E79"
    }
});

const ManageEmployeeForm = ({ disabled, onFormChange, classes, employee, orgId }) => {
    const [data, setData] = React.useState({
        departmentId: employee.departmentId,
        postId: employee.postId,
        startDate: employee.startDate,
        endDate: employee.endDate
    });

    const { dataSources, getForm } = useAddExistingForm();

    useEffect(() => {
      if (orgId && orgId > 0) {
        getForm(orgId);
      }
    }, [orgId]);

    const onChange = (field, value) => {
        const newState = {
            ...data,
            [field]: value
        };

        setData(newState);
        onFormChange(newState);
    };

    return (
        <div className={classes.root}>
          {employee.name && employee.name !== "" &&
            <div className={classes.curator}>
                <div className={classes.curatorPic}>
                    <Avatar alt="Employee" imageId={employee.avatar} />
                </div>
                <div>
                    <div className={classes.avatarName}>
                        {transformNameInfoInitials(employee.name)}
                    </div>
                    <div className={classes.avatarCaption}>
                        {employee.postName}
                    </div>
                </div>
            </div>}
            <DataSelect
                value={data.departmentId}
                onChange={value => onChange("departmentId", value.id)}
                label="Подразделение"
                dataSource={dataSources.departments}
            />
            <DataSelect
                value={data.postId}
                onChange={value => onChange("postId", value.id)}
                label="Должность"
                dataSource={dataSources.posts}
            />
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <TextField
                        required
                        value={data.startDate}
                        onChange={e => onChange("startDate", e.target.value)}
                        label="Дата начала работы"
                        disabled={disabled}
                        type="date"
                    />
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                    <TextField
                        required
                        value={data.endDate}
                        onChange={e => onChange("endDate", e.target.value)}
                        label="Дата увольнения"
                        disabled={disabled}
                        type="date"
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(ManageEmployeeForm);
